import { Button, Card, Modal } from "../../../../components";
import ClosestCircleSection from "./closestCircleSection";
import Localization from "../../../../localization";
import Collaborators from "./collaborators";
import GroupsSection from "./groupsSection";
import useViewModel from "../../viewModel";
import Inactive from "./inactive";
import Options from "./options";
import { useRef } from "react";
import { Flex } from "antd";

const Connect = ({
  progress,
  title = "",
  collaborators,
  readMoreUrl = "",
  onEditClick = () => {},
  ...props
}) => {
  const optionsModalRef = useRef();
  const { device } = useViewModel();
  return (
    <Card {...props} title={Localization.general.connect}>
      <ClosestCircleSection />
      <GroupsSection className="m-20-t" />
      <Flex className="m-30-t" gap={"1rem"}>
        {device.supportsSignals && (
          <Button
            ghost
            type="primary"
            title={Localization.general.more_options}
            onClick={() => optionsModalRef.current.open()}
          />
        )}
        <Button
          onClick={() => window.open(readMoreUrl)}
          title={Localization.general.learn_more}
        />
      </Flex>
      {device.supportsSignals && (
        <Modal title={Localization.general.connect} ref={optionsModalRef}>
          <Options />
          <Button
            type="primary"
            className="m-30-t"
            title={Localization.general.done}
            onClick={() => optionsModalRef.current.close()}
          />
        </Modal>
      )}
    </Card>
  );
};

Connect.Inactive = Inactive;
Connect.Collaborators = Collaborators;

export default Connect;
